import UmbracoFormsValidation from './umbraco-forms-validation';
import UmbracoFormsController from './umbraco-forms.controller';
export default function UmbracoForms(module) {
    UmbracoFormsValidation();
    UmbracoFormsController(module);
};